import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';

const timeline = document.querySelector('[js-timeline]')

if (timeline && window.innerWidth > 768) {
  const items = timeline.querySelectorAll('[js-timeline-item]')

  if (items && items.length > 3) {
    const swiper = new Swiper(timeline.querySelector('[js-timeline-slider]'), {
      slidesPerView: 3,
      loop: true,
      modules: [Autoplay],
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      }, 
    })
  }
}